import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  OnChanges,
} from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { NgZone, ViewChild } from '@angular/core';
import { take } from 'rxjs/operators';
import { DatePipe, formatDate } from '@angular/common';
import 'jqueryui';
import { HttpClient } from '@angular/common/http';
import { UpdationServiceService } from 'src/app/services/updation-service.service';
import { environment } from 'src/environments/environment';
import { TriggerHistoryDialogComponent } from '../trigger-history-dialog/trigger-history-dialog.component';
import { TriggerHistoryDialogService } from '../trigger-history-dialog/trigger-history-dialog.service';
import { MatDialog } from '@angular/material/dialog';
import { TriggerTemplateService } from 'src/app/services/trigger-template.service';

export interface DialogData {
  triggerData: Object
}
@Component({
  selector: 'app-dscr-template',
  templateUrl: './dscr-template.component.html',
  styleUrls: ['./dscr-template.component.css'],
  providers: [DatePipe]
})
export class DscrTemplateComponent implements OnInit, OnChanges {
  dropped = 0;
  all: string[] = [];
  even: string[] = [];
  originalIndex = 9;
  manualInputEnabled: boolean = true;
  triggerAssignedChecker!: string;
  stringTemp!: string;
  currentDate: any;
  isDisabled90: any;
  isDisabled30: any;
  resObject: any;
  splittedData: any;
  updateTriggerValue: any;
  triggerExt: any;
  triggerDescription: any;
  description: any;
  resSplit: any;
  desSplit: any;
  masterloadidTrepp: any;

  @Input() set triggerID(id: any) {
    this.userData.triggerID = id;
  }
  @Input() set loanKey(id: any) {
    this.userData.loanKey = id;
  }
  @Input() set triggerType(id: any) {
    this.userData.triggerType = id;
  }
  @Input() set loanNumber(id: any) {
    this.userData.loanNumber = id;
  }
  @Input() set bloombergID(id: any) {
    this.userData.bloombergID = id;
  }
  @Input() set triggerValue(id: any) {
    this.userData.triggerValue = id;
    this.triggerAssignedChecker = id;
  }

  @Input() set highlighted(text: string[]) {
    this.userData.highlight = text;
    this.all = text;
  }
  @Output() closeSideNav = new EventEmitter();
  userData = {
    loanKey: '',
    triggerID: '',
    triggerType: '',
    loanNumber: '',
    bloombergID: '',
    triggerValue: '',
    triggerDescription: '',
    highlight: [''],
  };
  public content!: string;
  myDate = new Date();
  constructor(private toastrService: ToastrService, private _ngZone: NgZone, private http: HttpClient,
    private updationService: UpdationServiceService, public dialog: MatDialog,
    private historyService: TriggerHistoryDialogService, private datePipe: DatePipe,
    private triggerTemplateService: TriggerTemplateService
  ) {
    let myDate = this.datePipe.transform(this.myDate, 'yyyy-MM-dd');
    this.content = this.userData.triggerDescription;
  }
  public query = this.userData.highlight;
  @ViewChild('autosize') autosize!: CdkTextareaAutosize;
  arr!: string[];
  trackTriggerDescription: boolean = true;
  detailData: any = [];
  dateExp: any;
  dateSnooze: any;
  timeExp: string = "";
  @Input() set custom_bool(custom: boolean) {
    this.custom = custom;
  }
  custom: boolean = false;
  @Input() dataSet: any;

  ngOnInit(): void {
    if (this.dataSet)
      this.dataSet.expirationDate = '';
    let element: HTMLElement = document.getElementsByClassName('draggable') as unknown as HTMLElement;
    element.click;
  }

  findNumber() {
    this.splittedData = this.triggerDescription.split(/([0-1]+\.(?:\d{1,2}|2\.00))[xX]?/gm);
    this.resSplit = this.splittedData.reduce(function (s: any, a: any) {
      s.push({ text: a, enableDrag: false });
      return s;
    }, []);
    this.resSplit.forEach((item: any) => {
      if (item.text.match(/^\d/)) {
        item.enableDrag = true;
      }
    });
  }

  ngOnChanges(): void {
    this.userData.triggerDescription = this.dataSet.loanTriggerSettings;
    this.masterloadidTrepp = this.dataSet.masterloanidtrepp;
    this.updateTriggerValue = this.dataSet.triggerValue;
    this.triggerExt = this.dataSet.triggerExtractions;
    this.triggerDescription = this.dataSet.triggerDescription;
    this.findNumber();
    this.description = this.dataSet.triggerDescription;
    if (this.dataSet.daySnooze != null) {
      this.currentDate = formatDate(this.dataSet.daySnooze, 'MM-dd-YYYY', 'en');
      this.isDisabled30 = true;
      this.isDisabled90 = true;
    } else {
      this.currentDate = '';
      this.isDisabled30 = false;
      this.isDisabled90 = false;
    }
  }

  dropIntoInput(ev: any) {
    this.updateTriggerValue = ev.dragData;
  }

  redirectToUrl(id: any) {
    window.open('https://propapi.rialtocapital.com/api/Redirection/RedirectToTrepp?masterPropertyTreppId='+ this.masterloadidTrepp, '_blank');
  }


  noReturnPredicate() {
    return true;
  }
  closeForm(): void {
    this.closeSideNav.emit();
  }
  showError() {
    this.toastrService.error(
      'Please Submit your Changes before Closing the Form'
    );
  }
  showSuccess() {
    var x = this.dataSet;
    x.triggerValue = Number(this.updateTriggerValue);
    this.toastrService.success('Your Changes have been Sent for Review!');
    this.triggerTemplateService.saveUpateTrigger(x).subscribe(
      (data) => {
        this.toastrService.success('Trigger Updated!');
        this.updationService.setDSCR(data);
      }
    );

  }
  triggerResize() {
    // Wait for changes to be applied, then trigger textarea resize.
    this._ngZone.onStable
      .pipe(take(1))
      .subscribe(() => this.autosize.resizeToFitContent(true));
  }
  textAreaAdjust(element: any) {
    element.style.height = '1px';
    element.style.height = 25 + element.scrollHeight + 'px';
  }

  openDialog(): void {
    this.historyService.getTriggerHistory(this.dataSet.id).subscribe((res: any) => {
      const triggerHistory = res.body;
      this.dialog.open(TriggerHistoryDialogComponent, {
        // height: '600px',
        // width: '600px',
        data: { data: triggerHistory }
      });
    })
  }

  calculateDiff(dateSent: any) {
    let currentDate = new Date();
    dateSent = new Date(dateSent);
    let days = Math.floor((currentDate.getTime() - dateSent.getTime()) / 1000 / 60 / 60 / 24);
    this.resObject.daySnooze = days;
  }

  snooze30(days: any) {
    this.toastrService.info('Saving snooze..');
    this.historyService.snoozeTrigger(days, this.dataSet.id).subscribe((res: any) => {
      this.resObject = res.body;
      if (res) {
        this.isDisabled30 = true;
        this.currentDate = formatDate(this.myDate, 'MM-dd-YYYY', 'en');
        let snoozedDate = formatDate(res.body.daySnooze, 'MM-dd-YYYY', 'en');
        this.calculateDiff(snoozedDate);
        this.toastrService.success('Trigger Snoozed 30 days');
        this.updationService.setDSCR(this.resObject);
      }

    }, (error: any) => {
      this.toastrService.error(error);
    })
  }

  snooze90(days: any) {
    this.toastrService.info('Saving snooze..');
    this.historyService.snoozeTrigger(days, this.dataSet.id).subscribe((res: any) => {
      this.resObject = res.body;
      if (res) {
        this.isDisabled90 = true;
        this.currentDate = formatDate(this.myDate, 'MM-dd-YYYY', 'en');
        let snoozedDate = formatDate(res.body.daySnooze, 'MM-dd-YYYY', 'en');
        this.calculateDiff(snoozedDate);
        this.toastrService.success('Trigger Snoozed 90 days');
        this.updationService.setDSCR(this.resObject);
      }

    }, (error: any) => {
      this.toastrService.error(error);
    })
  }

  unsnoozeTrigger() {
    this.toastrService.info('Unsnoozing trigger..');
    this.historyService.unsnoozeTrigger(this.dataSet.id).subscribe((res: any) => {
      this.isDisabled30 = false;
      this.isDisabled90 = false;
      this.currentDate = '';
      this.toastrService.success('Trigger Unsnoozed');
      this.updationService.setDSCR(res);

    }, (error: any) => {
      this.toastrService.error(error);
    })
  }
}

